import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import { FreeMode, Pagination, Navigation, Thumbs, Controller, EffectFade, Autoplay } from 'swiper/modules';
import Lenis from "lenis";
import { lenis } from "./misc.js";

function homepage() {
    const home_top = document.querySelector('[data-target="home_top"]');
    if (!home_top) { return; }
    lenis.stop();
    gsap.to(home_top, {autoAlpha:1, duration:.2})
    home_top.classList.remove('after:opacity-0');
    const home_intro_link = document.querySelector('[data-target="home_intro_link"]');
    const home_wrap = document.querySelector('[data-target="home_wrap"]');

    
    
    const home_intro_link_neck = document.querySelector('[data-target="home_intro_link_neck"]');
    const home_intro_link_arrow = document.querySelector('[data-target="home_intro_link_arrow"]');
    const home_intro_link_text = document.querySelector('[data-target="home_intro_link_text"]');
    const home_intro_p = document.querySelector('[data-target="home_intro_p"]');
    const home_intro = document.querySelector('[data-target="home_intro"]');
    const trusted_home = document.querySelector('[data-target="trusted_home"]');
    const h1_home = document.querySelector('[data-target="h1_home"]');

    const home_intro_h2 = document.querySelector('[data-target="home_intro_h2"]');
    const home_intro_p_2 = document.querySelector('[data-target="home_intro_p_2"]');

    const box_breaking_news = document.querySelector('[data-target="box_breaking_news"]');
    const close_breaking_news = document.querySelector('[data-target="close_breaking_news"]');
    const canvastop = home_top.querySelector('[data-target="webgl-container"');
    const homewebgl = document.querySelector('[data-webgl="loaded-object"');

   
    gsap.timeline({repeat: -1})
        .to(home_intro_link_arrow, {
            y: 10,
            duration: 0.2,
            ease: "power1.out"
        })
        .to(home_intro_link_arrow, {
            y: 0,
            duration: 2.3,
            delay:.2,
            ease: "power1.out"
        });
    
    const box1 = document.querySelector('#block-1');

    gsap.set(canvastop, {y:"-=70px"})
    let timeline_hometop = gsap.timeline({
        scrollTrigger: {
        trigger: home_top,
        pin: home_top,
        scrub: true,
        start: '-10px top',
        invalidateOnRefresh: true,
        end: "+=220%"
        }
    });
    
    timeline_hometop.to(
        home_intro_link,
        {scale:0, duration:0.5}, "start"
    )
    .to(home_intro_link_neck, {scaleX:1, scaleY:1.5,  duration:.4,  ease: "power3.out"}, "start")
    .to([home_intro_link_arrow, home_intro_link_text], {autoAlpha:0, duration:.3}, "start") 
    .to(home_intro_link, {
        x: () => window.innerWidth > 1024 ? 30 : -30,
        y: 30,
        duration: .6
    }, "start")
    .to([trusted_home,h1_home],
        {autoAlpha:0,duration:.4},  "start"
    )
    .to([home_intro_p],
        {autoAlpha:0,duration:.3},  "start"
    )
    

    .to(home_intro,
        {height:0,paddingTop:0, duration:.2},  "-=.3"
    )
    
    .to(home_intro,
        {scaleY:0, duration:.2, ease: "power3.out",}, "-=.32"
    )
    .to(canvastop, {y:"+=30px", duraion:.5}, .2)

    
    .to([home_intro_h2, home_intro_p_2], {autoAlpha:1, duration:.5}, .4)

    .to([home_intro_h2, home_intro_p_2, canvastop, box_breaking_news], {autoAlpha:0, duration:.2, delay:.15})

  
    gsap.to(box1, {
        opacity: 1,   
        y: 0,         
        duration: 1,  
        ease: "none", 
        scrollTrigger: {
            trigger: box1,     
            start: "top 50%",  
            end: "+=300px",    
            scrub: true,       
        }
    });

    const PLCboxes = document.querySelectorAll('[data-target="plc_box"]');

    PLCboxes.forEach(function(PLCbox) {
       
            // const iButton = PLCbox.querySelector('[data-target="i_button"]');
            // const gOpacity = PLCbox.querySelector('[data-target="g_opacity"]');

            // const h3 = PLCbox.querySelector('h3');
            // const tooltip = PLCbox.querySelector('[data-target="tooltip"]');
            // const taxonomy_txt = PLCbox.querySelector('[data-target="taxonomy_txt"]');
            
            // let tl, tlback;

            // iButton.addEventListener('mouseover', function() {
            //     if (tlback && tlback.isActive()) {
            //         tlback.kill();
            //     }

            //     tl = gsap.timeline();
            //     tl.to([h3, taxonomy_txt], {autoAlpha: 0, duration: 0.5}, "start")
            //       .to(gOpacity, {fillOpacity: 1, duration: 0.5}, "start")
            //       .to(tooltip, {autoAlpha: 1, duration: 0.3});
            // });

            // iButton.addEventListener('mouseout', function() {
            //     if (tl && tl.isActive()) {
            //         tl.kill();
            //     }

            //     tlback = gsap.timeline();
            //     tlback.to(tooltip, {autoAlpha: 0, duration: 0.3}, "start")
            //           .to(gOpacity, {fillOpacity: 0.2, duration: 0.5}, "start")
            //           .to([h3, taxonomy_txt], {autoAlpha: 1, duration: 0.5});
            // });
        
    });

    
    
    if(box_breaking_news) {
        close_breaking_news.addEventListener('click', function(event) {
			gsap.to(box_breaking_news, {autoAlpha:0, duration:.5})
		});
    }


    let timeline_introhome = gsap.timeline({delay:.5});
    

    window.scrollTo(0, 0);

    
    timeline_introhome.to([home_wrap],{autoAlpha:1,duration:1},  "start")
    .from(home_intro,{scaleY:0, duration:.2, ease: "power3.out"},  "introhome")
    .from(home_intro,{height:0,paddingTop:0, duration:.5},  "introhome")
    .from([home_intro_p],{autoAlpha:0,duration:.3},  "introhome")
    .from(home_intro_link, {x:30, y:30, duration:.6}, "introhome")
    .from([home_intro_link_arrow], {autoAlpha:0, duration:.3}, "introhome")
    .from(home_intro_link_neck, {scaleX:1, scaleY:1.5,  duration:.4,  ease: "power3.out"}, "introhome")
    .from(home_intro_link,{scale:0, duration:0.5}, "introhome")
    .to(homewebgl, {autoAlpha:1, duration:1.5},"=-1")
    .to(box_breaking_news, {autoAlpha:1, duration:1,onComplete: () => {lenis.start();  }},"=-1")
    

   
   
  
    
    

    
    
    
}


export { homepage }; 